<template>
  <div class="common-select">
    <el-select
      size="small"
      v-model="curSelected"
      v-loadmore="handleLoadMore"
      :placeholder="placeholder"
      :collapse-tags="isMultiple"
      :multiple="isMultiple"
      :filterable="filterable"
      :clearable="clearable"
      @change="handleChange"
    >
      <el-option v-if="needAll" :value="isMultiple ? 'all' : ''" :label="allText" />
      <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value" />
      <div v-if="pageLoading" class="loading">加载中</div>
    </el-select>
  </div>
</template>

<script>
/**
 * 通用选择输入组件，支持多选、分页
 */
export default {
  name: 'CommonSelect',
  props: {
    placeholder: {
      type: String,
      default: '请选择',
    },
    isMultiple: { // 是否多选
      type: Boolean,
      default: false,
    },
    options: { // 下拉选项
      type: Array,
      default: () => ([]),
    },
    selected: { // v-model中绑定显示
      type: [Array, String],
      default: '',
    },
    needAll: { // 是否可以选全部
      type: Boolean,
      default: false,
    },
    allText: { // 全部选项的文案
      type: String,
      default: '全部',
    },
    needPaging: { // 是否需要分页
      type: Boolean,
      default: false,
    },
    pageLoading: { // 是否正在加载下一页
      type: Boolean,
      default: false,
    },
    filterable: { // 是否支持搜索
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'selected',
    event: 'change',
  },
  data() {
    return {
      curSelected: this.isMultiple ? ['all'] : '',
    };
  },
  watch: {
    selected: {
      handler(newVal) {
        this.curSelected = newVal;
      },
      deep: true,
    },
  },
  methods: {
    // 选择变更处理
    handleChange(selected) {
      if (!this.isMultiple) {
        this.$emit('change', this.curSelected);
      } else {
        if (selected.slice(-1)[0] === 'all') { // 新选择的是全部，则变更为“全部”
          this.curSelected = ['all'];
        } else if (selected.includes('all')) { // 在选择了全部的情况下选了其他选项，去掉“全部”
          this.curSelected = this.curSelected.filter(item => item !== 'all');
        }
        this.$emit('change', this.curSelected); // v-model中绑定更改
      }
    },
    // 触底分页处理
    handleLoadMore() {
      if (this.needPaging && !this.pageLoading) {
        console.log('loadmore...');
        this.$emit('loadmore');
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.loading {
  font-size: 12px;
  color: #606266;
  text-align: center;
  padding: 5px 0;
}
/deep/ .el-tag.el-tag--info {
  max-width: 90%;
  display: flex;
  align-items: center;
  // white-space: normal;
  // height: 100%;
  // overflow: hidden;
  // max-width: 150px;
  // text-overflow: ellipsis;
  // word-break: break-all;
}
/deep/ .el-select__tags-text {
  width: auto;
  display: block;

  overflow: hidden;
  max-width: 120px;
  text-overflow: ellipsis;
  word-break: break-all;
}

/deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after {
  right: initial;
}
</style>
